import React, { useEffect, useMemo } from 'react';

import { LoadingDots } from '@reckon-web/loading';
import { Stack } from '@reckon-web/stack';
import { makeId } from '@reckon-web/utils';

import { useGetActivities } from '../../../data/useGetActivities';
import { dateCompare, maybeify } from '../../../utils/sort';
import { ActivityItem } from '../../activities/activity-item';

export const Activity: React.FC<{
  isOpen: boolean;
  jobId?: string | null;
  testId?: string;
}> = ({ isOpen, jobId, testId = `activity` }) => {
  const { data, error, refetch } = useGetActivities({
    variables: {
      id: jobId || '',
      targetType: 'Job',
    },

    skip: !jobId,
  });

  useEffect(() => {
    if (isOpen) refetch();
  }, [isOpen, refetch]);

  const sortedActivities = useMemo(
    () =>
      [...(data || [])].sort((a, b) =>
        maybeify(dateCompare, false)(a.initiatedOn, b.initiatedOn)
      ),
    [data]
  );

  // TODO: handle error and loading
  if (error) {
    return <div>Error</div>;
  }

  if (!data) {
    return (
      <LoadingDots
        label="Loading activities"
        data-testid={makeId(testId, 'loading-activities')}
      />
    );
  }

  return (
    <Stack gap="xlarge" paddingY="xlarge" dividers>
      {sortedActivities.map((activity) => (
        <ActivityItem
          activity={activity}
          key={activity.cloudId}
          testId={makeId(testId, 'activity-item', activity.cloudId)}
        />
      ))}
    </Stack>
  );
};
